/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Fintecy Investors API
 * API for managing investors, accounts, and transactions in the Fintecy platform
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { Error, GlobalSearchParams, SearchResponse } from '.././model';

import { customInstance } from '../../axios-instance';

/**
 * Search across accounts, transactions, goals, documents and other data
 * @summary Global search across all data types
 */
export const globalSearch = (params: GlobalSearchParams, signal?: AbortSignal) => {
  return customInstance<SearchResponse>({ url: `/api/search`, method: 'GET', params, signal });
};

export const getGlobalSearchQueryKey = (params: GlobalSearchParams) => {
  return [`/api/search`, ...(params ? [params] : [])] as const;
};

export const getGlobalSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof globalSearch>>,
  TError = Error,
>(
  params: GlobalSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof globalSearch>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGlobalSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof globalSearch>>> = ({ signal }) =>
    globalSearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof globalSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GlobalSearchQueryResult = NonNullable<Awaited<ReturnType<typeof globalSearch>>>;
export type GlobalSearchQueryError = Error;

export function useGlobalSearch<TData = Awaited<ReturnType<typeof globalSearch>>, TError = Error>(
  params: GlobalSearchParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof globalSearch>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof globalSearch>>,
          TError,
          Awaited<ReturnType<typeof globalSearch>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGlobalSearch<TData = Awaited<ReturnType<typeof globalSearch>>, TError = Error>(
  params: GlobalSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof globalSearch>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof globalSearch>>,
          TError,
          Awaited<ReturnType<typeof globalSearch>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGlobalSearch<TData = Awaited<ReturnType<typeof globalSearch>>, TError = Error>(
  params: GlobalSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof globalSearch>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Global search across all data types
 */

export function useGlobalSearch<TData = Awaited<ReturnType<typeof globalSearch>>, TError = Error>(
  params: GlobalSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof globalSearch>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGlobalSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
